// extracted by mini-css-extract-plugin
export var contentWrap = "MenuItemTile-module--contentWrap--0d745";
export var description = "MenuItemTile-module--description--0ff0f";
export var iconWrap = "MenuItemTile-module--iconWrap--fc7bf";
export var root = "MenuItemTile-module--root--bb1ca";
export var title = "MenuItemTile-module--title--f6608";